import { SelectInvoiceModal, TemplateSelectionModal } from '@frontend/integrated-messaging';
import { PaymentsFeatureFlags } from '@frontend/payments-hooks';
import { FeatureUpgradeModalWrapper } from '@frontend/self-upgrade';
import { useAppFlagStore } from '@frontend/shared';
import { UseInboxTemplateFlowsResults } from '../hooks';
import { FormsTemplateModal } from './forms-template-modal';
import { MultiCollectSelectInvoiceModal } from './multi-collect-select-invoice-modal';
import { ScheduleTemplateModal } from './schedule-template-modal';

type InboxTemplatesModalsProps = UseInboxTemplateFlowsResults['modalsProps'];

export const InboxTemplatesModals = ({
  manualTemplateModalProps,
  scheduleTemplateModalProps,
  reviewInvitationModalProps,
  selectInvoiceModalProps,
  formsTemplateModalProps,
  formsPromotionModalProps,
}: InboxTemplatesModalsProps) => {
  const { featureFlags } = useAppFlagStore();
  const showMultiProcessorCollect = !!featureFlags[selectInvoiceModalProps.groupId]?.get(
    PaymentsFeatureFlags.UseMultiProcessorCollect
  )?.value;

  return (
    <>
      <TemplateSelectionModal {...manualTemplateModalProps} />
      <ScheduleTemplateModal {...scheduleTemplateModalProps} />
      <TemplateSelectionModal {...reviewInvitationModalProps} />
      {showMultiProcessorCollect ? (
        <MultiCollectSelectInvoiceModal {...selectInvoiceModalProps} />
      ) : (
        <SelectInvoiceModal {...selectInvoiceModalProps} />
      )}
      <FormsTemplateModal {...formsTemplateModalProps} />
      <FeatureUpgradeModalWrapper {...formsPromotionModalProps} />
    </>
  );
};
